export default __webpack_public_path__ + "static/cuisiniere-a-bois-07e21692ccbac45f439e3b69fe533a4a.jpg";